import { render, staticRenderFns } from "./SalesForceOpportunityBillingDetail.vue?vue&type=template&id=2e63114a&scoped=true&"
import script from "./SalesForceOpportunityBillingDetail.vue?vue&type=script&lang=js&"
export * from "./SalesForceOpportunityBillingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e63114a",
  null
  
)

export default component.exports